module.exports = __webpack_public_path__ + "static/media/cameraSelected.78e64567.svg";